import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Amenity from '../models/Amenity';
import Urls from './../api/Urls';

const headers = {
    tenantId: Config.HOTEL_TENANT_ID,
}

export function getAmenity() {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AMENITY_LIST,
        parser: amenitiesDataParser,
        headers
    }).get();
}

export function getAllAmenityAvailability() {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.AMENITY_AVAILABILITY,
        parser: amenitiesDataParser,
        headers
    }).get();
}

export function getAmenityDetail(id) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AMENITY_DETAIL,
        endpointParams: { id },
        parser: (data) => new Amenity(data),
        headers
    }).get();
}

export function createAmenityDetail(amenity) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AMENITY_ACTION,
        parser: (data) => new Amenity(data.amenity),
        headers
    }).post(amenity.export());
}

export function updateAmenityDetail(amenity) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AMENITY_ACTION,
        parser: (data) => new Amenity(data.amenity),
        headers
    }).put(amenity.export());
}

export function deleteAmenityDetail(amenity) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AMENITY_DETAIL,
        endpointParams: { id: amenity.id },
        headers
    }).delete();
}

export function createAmenityTranslate(amenity) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AMENITY_TRANSLATE_CREATE,
        headers
    }).post(amenity.export(true).translate());
}

export function updateAmenityTranslate(amenity) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AMENITY_TRANSLATE_UPDATE,
        headers
    }).put(amenity.export(true).translate());
}

export function deleteAmenityTranslate(id) {
    return new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.AMENITY_TRANSLATE_DELETE,
        endpointParams: { id },
        headers
    }).delete();
}

const amenitiesDataParser = (data) => ({
    result: (data || []).map(item => new Amenity(item))
})
